import z from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import {
  INCIDENT_INBOX_FILTERS,
  INCIDENT_INBOX_SORTS,
} from '@workspace/utils/types/incident-inbox'
import { requireActiveSubscription } from '@/lib/middleware'
import { IncidentListRoute } from '@/features/incidents/v2/incident-list-route'

const incidentsSearchSchema = z.object({
  page: z.number().optional().catch(1),
  pageSize: z.number().optional().catch(10),
  status: z.string().optional().catch(''),
  severity: z.string().optional().catch(''),
  incidentType: z.string().optional().catch(''),
  search: z.string().optional().catch(''),
  // The v2 incident response inbox (shown when the incident workflow is active).
  filter: z.enum(INCIDENT_INBOX_FILTERS).optional().catch(undefined),
  sort: z.enum(INCIDENT_INBOX_SORTS).optional().catch(undefined),
  facilityId: z.string().uuid().optional().catch(undefined),
  ownerMemberId: z.string().uuid().optional().catch(undefined),
})

export const Route = createFileRoute(
  '/_authenticated/_organization/incidents/'
)({
  beforeLoad: async () => requireActiveSubscription(),
  component: IncidentListRoute,
  validateSearch: incidentsSearchSchema,
})
